{
    "ReportIntervalLanguageFifteenMinutes": "15 Minuten",
    "ReportIntervalLanguageThirtyMinutes": "30 Minuten",
    "ReportIntervalLanguageOneHour": "1 Stunde",
    "ReportIntervalLanguageTwoHour": "2 Stunden",
    "ReportIntervalLanguageTypeMinute": "Protokoll",
    "ReportIntervalLanguageTypeHour": "Stunde",
    "ReportIntervalLanguageTypeHourPluralised": "Stunden",
    "ReportIntervalLanguageInterpolated": "Anrufe insgesamt von {} {}",
    "ReportIntervalLanguageCallByInterpolated": "Anrufe von {} {}",
    "ReportIntervalLanguageCallByNoValueInterpolated": "Anrufe von {}",
    "ReportIntervalTypeMinutes": "Protokoll",
    "ReportIntervalTypeHours": "Stunden",
    "ReportIntervalTypeDay": "Tag",
    "ReportIntervalTypeWeek": "Woche",
    "ReportIntervalTypeMonth": "Monat",
    "NAME": "ReportIntervalLanguage",
    "ReportIntervalEntityLanguageCallByNoValueInterpolated": "Anrufe von {} ({})",
    "ReportIntervalEntityLanguageCallByInterpolated": "Aufrufe von {} {} ({})",
    "ReportIntervalTypeDayOfTheWeek": "Wochentag",
    "ReportIntervalEntityTypeDevicesExtensionsAA": "Geräte (Erweiterungen\/AA)",
    "ReportIntervalEntityTypeAgents": "Agenten",
    "ReportIntervalEntityTypeGroups": "Gruppen\/Warteschlangen",
    "ReportIntervalEntityTypeDNIS": "DNIS"
}